import React, { useState, useRef } from "react";
import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import {
    Paper,
    Table,
    MenuItem,
    TableBody,
    Select,
    TableCell,
    TableContainer,
    TableHead,
    TablePagination,
    TableRow,
    withStyles,
    Dialog,
    DialogContent,
    DialogTitle,
    IconButton,
    Chip,
    Typography,
    Avatar,
    Tooltip,
} from "@material-ui/core";
import Box from "@mui/material/Box";
import { AvatarGroup } from "@material-ui/lab";
import Button from "@mui/material/Button";
import { connect } from "react-redux";
import { InputAdornment } from "@material-ui/core";
import { OutlinedInput } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { useEffect } from "react";
import { useHistory } from "react-router";
import {
    getTechTicket,
    postTechTicket,
    postTechTicketIssueAttacment,
    postTechTicketComment,
    getTechTicketActivites,
    getTechTicketComments,
    getTechTicketAttacment,
    getTechTicketUserDetails
} from "../../actions/OffLineSupportActions";
import { Grid, TextField } from "@material-ui/core";
import VisibilityIcon from "@material-ui/icons/Visibility";
import AddIcon from "@material-ui/icons/Add";
import SearchIcon from "@material-ui/icons/Search";
import { Upload } from "@mui/icons-material";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 0,
        },
        content: {
            width: "100%",
            padding: theme.spacing(3),
            backgroundColor: "#f8fafc",
            minHeight: "100vh",
            marginTop: "30px"
        },
        header: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: theme.spacing(3),
        },
        title: {
            fontSize: "28px",
            fontWeight: 700,
            color: "#1a1a1a",
        },
        searchBox: {
            backgroundColor: "white",
            borderRadius: "8px",
            "& .MuiOutlinedInput-root": {
                borderRadius: "10px",
                height: "48px",
            },

            "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "#E2E8F0",
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
                borderColor: "#CBD5E1",
            },
            "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: "#7c3aed",
            },
        },
        filterSelect: {
            backgroundColor: "#fff",
        },
        tableContainer: {
            borderRadius: "8px",
            boxShadow: "none",
            border: "1px solid #e2e8f0",
            "& .MuiTableCell-root": {
                fontSize: "14px",
                padding: "12px 16px",
            },
        },
        // Create Modal Styles
        dialog: {
            "& .MuiDialog-paper": {
                borderRadius: "12px",
                maxWidth: "900px",
                width: "100%",
            },
        },
        dialogTitle: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "24px 24px 16px",
            borderBottom: "1px solid #e0e0e0",
        },
        titleText: {
            fontSize: "20px",
            fontWeight: 600,
            color: "#1a1a1a",
        },
        closeButton: {
            color: "#666",
            "&:hover": {
                backgroundColor: "#f5f5f5",
            },
        },
        dialogContent: {
            padding: "24px",
            maxHeight: "70vh",
            overflowY: "auto",
        },
        sectionTitle: {
            fontSize: "14px",
            fontWeight: 600,
            color: "#666",
            marginBottom: "8px",
            textTransform: "uppercase",
            letterSpacing: "0.5px",
        },
        descriptionField: {
            "& .MuiOutlinedInput-root": {
                borderRadius: "8px",
                minHeight: "120px",
                alignItems: "flex-start",
            },
        },
        editorToolbar: {
            display: "flex",
            gap: "4px",
            padding: "8px",
            borderBottom: "1px solid #e0e0e0",
            backgroundColor: "#fafafa",
            borderTopLeftRadius: "8px",
            borderTopRightRadius: "8px",
            flexWrap: "wrap",
        },
        editorButton: {
            minWidth: "32px !important",
            height: "32px !important",
            padding: "4px 8px !important",
            color: "#666 !important",
            border: "1px solid transparent",
            borderRadius: "4px !important",
            fontSize: "14px",
            fontWeight: 500,
            transition: "all 0.2s",
            "&:hover": {
                backgroundColor: "#e0e0e0 !important",
                borderColor: "#d0d0d0",
            },
        },
        editorContainer: {
            border: "1px solid #e0e0e0",
            borderRadius: "8px",
            overflow: "hidden",
        },
        editorTextarea: {
            "& .MuiOutlinedInput-root": {
                borderRadius: "0 0 8px 8px",
                "& fieldset": {
                    border: "none",
                },
            },
            "& textarea": {
                resize: "vertical",
                minHeight: "120px",
            },
        },
        actionButtons: {
            display: "flex",
            gap: "12px",
            marginTop: "24px",
        },
        polishButton: {
            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
            color: "white",
            borderRadius: "8px",
            padding: "10px 20px",
            textTransform: "none",
            fontWeight: 600,
            "&:hover": {
                background: "linear-gradient(135deg, #5568d3 0%, #65408b 100%)",
            },
        },
        generateButton: {
            background: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
            color: "white",
            borderRadius: "8px",
            padding: "10px 20px",
            textTransform: "none",
            fontWeight: 600,
            "&:hover": {
                background: "linear-gradient(135deg, #d97ee4 0%, #de4a5d 100%)",
            },
        },
        priorityChip: {
            borderRadius: "16px",
            fontWeight: 600,
            padding: "4px 12px",
            cursor: "pointer",
            transition: "all 0.2s",
            "&:hover": {
                transform: "scale(1.05)",
            },
        },
        submitButton: {
            background: "#7c3aed",
            color: "white",
            borderRadius: "8px",
            padding: "10px 32px",
            textTransform: "none",
            fontWeight: 600,
            "&:hover": {
                background: "#6d28d9",
            },
        },
        cancelButton: {
            borderRadius: "8px",
            padding: "10px 32px",
            textTransform: "none",
            fontWeight: 600,
            color: "#666",
            borderColor: "#e0e0e0",
            "&:hover": {
                borderColor: "#bdbdbd",
                backgroundColor: "#f5f5f5",
            },
        },
        // Enhanced Table Styles
        ticketId: {
            fontWeight: 600,
            color: "#64748b",
            fontSize: "14px",
        },
        ticketTitle: {
            fontWeight: 500,
            color: "#1a1a1a",
            fontSize: "14px",
        },
        stateChip: {
            borderRadius: "6px",
            fontWeight: 600,
            fontSize: "12px",
            padding: "4px 12px",
            height: "28px",
        },
        priorityIndicator: {
            display: "flex",
            alignItems: "center",
            gap: "8px",
        },
        priorityBar: {
            width: "3px",
            height: "20px",
            borderRadius: "2px",
        },
        priorityText: {
            fontSize: "13px",
            fontWeight: 500,
            color: "#64748b",
        },
        avatarGroup: {
            "& .MuiAvatar-root": {
                width: "28px",
                height: "28px",
                fontSize: "12px",
                border: "2px solid white",
            },
        },
        actionButton: {
            padding: "6px",
            color: "#64748b",
            "&:hover": {
                backgroundColor: "#f1f5f9",
            },
        },
        dateText: {
            fontSize: "13px",
            color: "#94a3b8",
        },
        // View Dialog Styles
        viewDialog: {
            "& .MuiDialog-paper": {
                borderRadius: "12px",
                maxWidth: "800px",
                width: "100%",
            },
        },
        detailRow: {
            display: "flex",
            marginBottom: "20px",
            "&:last-child": {
                marginBottom: 0,
            },
        },
        detailLabel: {
            fontSize: "14px",
            fontWeight: 600,
            color: "#64748b",
            minWidth: "140px",
            textTransform: "uppercase",
            letterSpacing: "0.5px",
        },
        detailValue: {
            fontSize: "14px",
            color: "#1a1a1a",
            flex: 1,
        },
        descriptionBox: {
            backgroundColor: "#f8fafc",
            padding: "16px",
            borderRadius: "8px",
            border: "1px solid #e2e8f0",
            marginTop: "8px",
            whiteSpace: "pre-wrap",
            wordBreak: "break-word",
            "& img": {
                maxWidth: "100%",
                height: "auto",
                borderRadius: "8px",
                marginTop: "12px",
                marginBottom: "12px",
                display: "block",
            },
        },
        assigneesList: {
            display: "flex",
            gap: "12px",
            flexWrap: "wrap",
            marginTop: "8px",
        },
        assigneeItem: {
            display: "flex",
            alignItems: "center",
            gap: "8px",
            padding: "6px 12px",
            backgroundColor: "#f8fafc",
            borderRadius: "20px",
            border: "1px solid #e2e8f0",
        },
        attachmentGrid: {
            display: "grid",
            gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))",
            gap: "12px",
            marginTop: "12px",
        },
        attachmentCard: {
            border: "1px solid #e2e8f0",
            borderRadius: "8px",
            overflow: "hidden",
            cursor: "pointer",
            transition: "all 0.2s",
            "&:hover": {
                borderColor: "#7c3aed",
                boxShadow: "0 2px 8px rgba(124, 58, 237, 0.1)",
            },
        },
        attachmentImage: {
            width: "100%",
            height: "120px",
            objectFit: "cover",
            backgroundColor: "#f8fafc",
        },
        attachmentInfo: {
            padding: "8px 12px",
            backgroundColor: "white",
        },
        attachmentName: {
            fontSize: "12px",
            fontWeight: 500,
            color: "#1a1a1a",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
        },
        attachmentSize: {
            fontSize: "11px",
            color: "#94a3b8",
            marginTop: "2px",
        },
        addFileButton: {
            border: "2px dashed #e2e8f0",
            borderRadius: "8px",
            padding: "20px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            transition: "all 0.2s",
            minHeight: "120px",
            "&:hover": {
                borderColor: "#7c3aed",
                backgroundColor: "#f8fafc",
            },
        },
        commentsSection: {
            marginTop: "24px",
            borderTop: "1px solid #e2e8f0",
            paddingTop: "20px",
        },
        commentsList: {
            display: "flex",
            flexDirection: "column",
            gap: "20px",
            marginBottom: "24px",
            maxHeight: "400px",
            overflowY: "auto",
            padding: "8px",
        },
        commentItem: {
            display: "flex",
            gap: "12px",
            padding: "16px",
            backgroundColor: "#ffffff",
            borderRadius: "12px",
            border: "1px solid #e2e8f0",
            transition: "all 0.2s ease",
            "&:hover": {
                borderColor: "#cbd5e1",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.05)",
            },
        },
        commentAvatar: {
            flexShrink: 0,
            width: "40px",
            height: "40px",
            borderRadius: "50%",
            backgroundColor: "#7c3aed",
            color: "white",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontWeight: 600,
            fontSize: "14px",
        },
        commentContent: {
            flex: 1,
            minWidth: 0,
        },
        commentHeader: {
            display: "flex",
            alignItems: "center",
            gap: "12px",
            marginBottom: "8px",
            flexWrap: "wrap",
        },
        commentAuthor: {
            fontSize: "14px",
            fontWeight: 600,
            color: "#1a1a1a",
        },
        commentTime: {
            fontSize: "12px",
            color: "#64748b",
            backgroundColor: "#f1f5f9",
            padding: "2px 8px",
            borderRadius: "12px",
        },
        commentText: {
            fontSize: "14px",
            color: "#334155",
            lineHeight: "1.6",
            backgroundColor: "#f8fafc",
            padding: "12px 16px",
            borderRadius: "8px",
            border: "1px solid #e2e8f0",
            wordBreak: "break-word",
        },
        commentInputBox: {
            display: "flex",
            gap: "12px",
            alignItems: "flex-start",
        },
        commentTextField: {
            flex: 1,
            "& .MuiOutlinedInput-root": {
                borderRadius: "8px",
            },
        },
        tabsContainer: {
            borderBottom: "1px solid #e2e8f0",
            marginBottom: "16px",
        },
        tab: {
            padding: "8px 16px",
            fontSize: "14px",
            fontWeight: 600,
            color: "#64748b",
            cursor: "pointer",
            borderBottom: "2px solid transparent",
            transition: "all 0.2s",
            "&:hover": {
                color: "#7c3aed",
            },
        },
        activeTab: {
            color: "#7c3aed",
            borderBottomColor: "#7c3aed",
        },
        descriptionPreview: {
            backgroundColor: "#f8fafc",
            padding: "16px",
            borderRadius: "8px",
            border: "1px solid #e2e8f0",
            marginTop: "8px",
            minHeight: "120px",
            maxHeight: "400px",
            overflowY: "auto",
            "& img": {
                maxWidth: "100%",
                height: "auto",
                borderRadius: "8px",
                marginTop: "12px",
                marginBottom: "12px",
                display: "block",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
            },
            "& p": {
                margin: "8px 0",
                lineHeight: "1.6",
            },
        },
    })
);

const StyledTableCell: any = withStyles((theme: Theme) =>
    createStyles({
        head: {
            backgroundColor: "white",
            color: "#64748b",
            fontSize: "12px",
            fontWeight: 600,
            textTransform: "uppercase",
            letterSpacing: "0.5px",
            borderBottom: "1px solid #e2e8f0",
            padding: "12px 16px",
        },
        body: {
            fontSize: 14,
            borderBottom: "1px solid #f1f5f9",
            padding: "12px 16px",
        },
    })
)(TableCell);

const StyledTableRow: any = withStyles((theme: Theme) =>
    createStyles({
        root: {
            "&:hover": {
                backgroundColor: "#f8fafc",
            },
            transition: "all 0.15s",
        },
    })
)(TableRow);

interface Props {
    getTechTicket: any;
    techTicketDetails: any;
    postTechTicket: any;
    postTechTicketIssueAttacment: any
    postTechTicketComment: any
    getTechTicketActivites: any
    techTicketActivities: any
    getTechTicketComments: any
    techTicketComments: any
    getTechTicketAttacment: any
    techTicketAttacments: any
    getTechTicketUserDetails: any
    techTicketUserDetails: any
    userDetails: any
}

// Helper function to get file icon and color based on file type
const getFileIcon = (attachment: any) => {
    const { mime_type, is_image, is_pdf, original_filename } = attachment;

    // Image files
    if (is_image) {
        return { emoji: "🖼️", color: "#10b981" };
    }

    // PDF files
    if (is_pdf) {
        return { emoji: "📄", color: "#ef4444" };
    }

    // Word documents
    if (mime_type?.includes('wordprocessingml') ||
        mime_type?.includes('msword') ||
        original_filename?.match(/\.(doc|docx)$/i)) {
        return { emoji: "📘", color: "#2563eb" };
    }

    // Excel files
    if (mime_type?.includes('spreadsheetml') ||
        mime_type?.includes('excel') ||
        original_filename?.match(/\.(xls|xlsx|csv)$/i)) {
        return { emoji: "📊", color: "#059669" };
    }

    // PowerPoint files
    if (mime_type?.includes('presentationml') ||
        mime_type?.includes('powerpoint') ||
        original_filename?.match(/\.(ppt|pptx)$/i)) {
        return { emoji: "📽️", color: "#dc2626" };
    }

    // Text files
    if (mime_type?.includes('text') ||
        original_filename?.match(/\.(txt|md|json|xml)$/i)) {
        return { emoji: "📝", color: "#64748b" };
    }

    // Zip/Archive files
    if (mime_type?.includes('zip') ||
        mime_type?.includes('compressed') ||
        original_filename?.match(/\.(zip|rar|7z|tar|gz)$/i)) {
        return { emoji: "🗜️", color: "#8b5cf6" };
    }

    // Video files
    if (mime_type?.includes('video') ||
        original_filename?.match(/\.(mp4|avi|mov|wmv|flv|mkv)$/i)) {
        return { emoji: "🎥", color: "#ec4899" };
    }

    // Audio files
    if (mime_type?.includes('audio') ||
        original_filename?.match(/\.(mp3|wav|ogg|m4a|flac)$/i)) {
        return { emoji: "🎵", color: "#f59e0b" };
    }

    // Default for unknown types
    return { emoji: "📎", color: "#94a3b8" };
};

// Helper function to get file type label
const getFileTypeLabel = (attachment: any) => {
    const { mime_type, is_pdf, original_filename } = attachment;

    if (is_pdf) return 'PDF';
    if (mime_type?.includes('wordprocessing')) return 'DOCX';
    if (mime_type?.includes('spreadsheet')) return 'XLSX';
    if (mime_type?.includes('presentation')) return 'PPTX';

    const extension = original_filename?.split('.').pop()?.toUpperCase();
    return extension || 'FILE';
};

// Helper function to render description with embedded images
const renderDescriptionWithImages = (description: string) => {
    if (!description) return "No description provided";

    // Split description by image markdown pattern
    const parts = description.split(/!\[([^\]]*)\]\(([^)]+)\)/g);
    const elements: any[] = [];

    for (let i = 0; i < parts.length; i++) {
        if (i % 3 === 0) {
            // Text content
            if (parts[i]) {
                elements.push(
                    <Typography key={`text-${i}`} component="span" style={{ fontSize: "14px", lineHeight: "1.6", whiteSpace: "pre-wrap" }}>
                        {parts[i]}
                    </Typography>
                );
            }
        } else if (i % 3 === 2) {
            // Image URL (parts[i-1] is alt text, parts[i] is URL)
            elements.push(
                <img
                    key={`img-${i}`}
                    src={parts[i]}
                    alt={parts[i - 1] || "Uploaded image"}
                    style={{
                        maxWidth: "100%",
                        height: "auto",
                        borderRadius: "8px",
                        marginTop: "12px",
                        marginBottom: "12px",
                        display: "block",
                        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                    }}
                />
            );
        }
    }

    return <>{elements}</>;
};

const BookingsTable: React.FC<Props> = ({
    getTechTicket,
    techTicketDetails,
    postTechTicket,
    postTechTicketIssueAttacment,
    postTechTicketComment,
    getTechTicketActivites,
    techTicketActivities,
    getTechTicketComments,
    techTicketComments,
    getTechTicketAttacment,
    techTicketAttacments,
    getTechTicketUserDetails,
    techTicketUserDetails,
    userDetails
}) => {
    const history = useHistory();
    const classes = useStyles();

    // Create Modal States
    const [openCreateModal, setOpenCreateModal] = useState(false);
    const [createFormData, setCreateFormData] = useState({
        title: "",
        description: "",
        priority: 0,
    });
    const [uploadedImages, setUploadedImages] = useState<Array<{ name: string, data: string }>>([]);
    const descriptionRef = useRef<HTMLTextAreaElement>(null);

    // View Modal States
    const [openViewModal, setOpenViewModal] = useState(false);
    const [selectedTicket, setSelectedTicket] = useState<any>(null);
    const [newComment, setNewComment] = useState("");
    const [activeTab, setActiveTab] = useState<"history" | "comments" | "attachments">("comments");
    const [attachments, setAttachments] = useState<any[]>([]);

    const priorities = [
        { label: "None", value: 0, color: "#9ca3af" },
        { label: "Low", value: 1, color: "#10b981" },
        { label: "Medium", value: 2, color: "#f59e0b" },
        { label: "High", value: 3, color: "#ef4444" },
        { label: "Urgent", value: 4, color: "#dc2626" },
    ];

    // Rich text editor handlers
    const insertText = (before: string, after: string = "") => {
        const textarea = descriptionRef.current;
        if (!textarea) return;

        const start = textarea.selectionStart;
        const end = textarea.selectionEnd;
        const selectedText = createFormData.description.substring(start, end);
        const newText =
            createFormData.description.substring(0, start) +
            before +
            selectedText +
            after +
            createFormData.description.substring(end);

        setCreateFormData({ ...createFormData, description: newText });

        // Reset cursor position
        setTimeout(() => {
            textarea.focus();
            textarea.setSelectionRange(
                start + before.length,
                end + before.length
            );
        }, 0);
    };

    const handleBold = () => insertText("**", "**");
    const handleItalic = () => insertText("*", "*");
    const handleUnderline = () => insertText("<u>", "</u>");
    const handleStrikethrough = () => insertText("~~", "~~");
    const handleCode = () => insertText("`", "`");
    const handleQuote = () => insertText("> ");
    const handleBulletList = () => insertText("- ");
    const handleNumberedList = () => insertText("1. ");
    const [selectedLabel, setSelectedLabel] = useState<any>("");

    console.log(techTicketUserDetails, "techTicketUserDetails")

    const handleImageUpload = () => {
        const input = document.createElement("input");
        input.type = "file";
        input.accept = "image/*";
        input.onchange = (e: any) => {
            const file = e.target.files[0];
            if (file) {
                const reader = new FileReader();
                reader.onload = (event: any) => {
                    const imageUrl = event.target.result;
                    // Store the image separately instead of in description
                    setUploadedImages(prev => [...prev, { name: file.name, data: imageUrl }]);
                };
                reader.readAsDataURL(file);
            }
        };
        input.click();
    };

    const handleLinkInsert = () => {
        const url = prompt("Enter URL:");
        if (url) {
            const text = prompt("Enter link text:") || url;
            insertText(`[${text}](${url})`);
        }
    };

    const handleViewTicket = (ticket: any) => {
        setSelectedTicket(ticket);
        setOpenViewModal(true);
        setNewComment("");
        setActiveTab("comments");
        // Load attachments if they exist in ticket data
        if (ticket.attachments) {
            setAttachments(ticket.attachments);
        } else {
            setAttachments([]);
        }
        // Fetch activities and comments for this ticket
        getTechTicketActivites(ticket.id);
        getTechTicketComments(ticket.id);
        getTechTicketAttacment(ticket.id);
    };

    const handleAddComment = () => {
        if (newComment.trim()) {
            const commentPayload = {
                issue_id: selectedTicket.id,
                content: newComment,
                user_id: techTicketUserDetails?.id
            };

            postTechTicketComment(commentPayload);
            setNewComment("");

            // Refresh comments list after posting
            setTimeout(() => {
                getTechTicketComments(selectedTicket.id);
            }, 500); // Small delay to ensure the comment is posted first
        }
    };

    const handleFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
        const files = event.target.files;
        if (files && files.length > 0) {
            const file = files[0];

            // Create FormData for file upload
            const formData = new FormData();
            formData.append('file', file);

            // Upload file using the action
            postTechTicketIssueAttacment({
                id: selectedTicket.id,
                formData: formData,
                uploaded_by: techTicketUserDetails?.id
            });

            // Refresh attachments list after uploading
            setTimeout(() => {
                getTechTicketAttacment(selectedTicket.id);
            }, 500); // Small delay to ensure the file is uploaded first
        }
    };

    const triggerFileUpload = () => {
        const input = document.createElement("input");
        input.type = "file";
        input.onchange = (e: any) => handleFileUpload(e);
        input.click();
    };

    // useEffect(() => {
    //     getTechTicket("");
    // }, []);


    console.log(techTicketDetails, "idncidscnsdiocd")
    useEffect(() => {
        if (userDetails && userDetails.profile && userDetails.profile.email !== null) {
            const email = userDetails.profile.email;
            getTechTicketUserDetails(email);
        }
    }, [userDetails]);

    const [page, setPage] = useState(0);
    const [searchQuery, setSearchQuery] = useState("");
    const [selectedStatus, setSelectedStatus] = useState<any>("");
    const [selectedPriority, setSelectedPriority] = useState<any>("");

    useEffect(() => {
        handleSearch();
    }, [selectedStatus, selectedPriority, selectedLabel]);

    const handleChangePage = (
        event: React.MouseEvent<HTMLButtonElement> | null,
        newPage: number
    ) => {
        setPage(newPage);

        // Construct pagination URL based on current filters
        let queryParams = [];
        if (selectedLabel) queryParams.push(`label=${selectedLabel}`);
        if (searchQuery) queryParams.push(`search=${searchQuery}`);
        if (selectedStatus) queryParams.push(`state=${selectedStatus}`);
        if (selectedPriority) queryParams.push(`priority=${selectedPriority}`);

        // Add page parameter
        queryParams.push(`page=${newPage + 1}`); // API pages are 1-indexed

        const queryString = queryParams.join('&');
        getTechTicket(`?${queryString}`);
    };

    const handleCreateTicket = () => {
        // Combine description with uploaded images
        let fullDescription = createFormData.description;
        if (uploadedImages.length > 0) {
            const imageMarkdown = uploadedImages.map(img => `\n![${img.name}](${img.data})`).join('\n');
            fullDescription = fullDescription + imageMarkdown;
        }

        const payload = {
            name: createFormData.title,
            description: fullDescription,
            description_html: `<p>${fullDescription}</p>`,
            priority: createFormData.priority,
            project_id: "abaa4885-7740-413c-9f6d-4d122ef14a2c",
            assignee_ids: ["b73e7f20-3653-48ff-b7c7-b8c730395b58", "3ed78844-19ea-46e5-8f97-72991249a6f0"],
            created_by: techTicketUserDetails?.[0]?.id,
            state_id: "5553a160-6332-4e4d-8124-23b7e9f7fb41",
            labels: ["offlineSupport"]
        };

        console.log("Creating ticket:", payload);
        postTechTicket(payload).then(() => {
            setOpenCreateModal(false);
            setCreateFormData({
                title: "",
                description: "",
                priority: 0,
            });
            setUploadedImages([]);
            // Reset page to 0 and refresh data
            setPage(0);
            getTechTicket("");
        });
    };

    const getStateColor = (state: string) => {
        const colors: any = {
            todo: { bg: "#e0e7ff", color: "#4338ca" },
            in_progress: { bg: "#dbeafe", color: "#1e40af" },
            done: { bg: "#d1fae5", color: "#065f46" },
            no_state: { bg: "#f1f5f9", color: "#64748b" },
        };
        return colors[state] || colors.no_state;
    };

    const getPriorityColor = (priority: string) => {
        const colors: any = {
            none: "#9ca3af",
            low: "#10b981",
            medium: "#f59e0b",
            high: "#ef4444",
            urgent: "#dc2626",
        };
        return colors[priority] || colors.none;
    };

    const handleReset = () => {
        setSearchQuery("");
        setSelectedStatus("");
        setSelectedPriority("");
        setSelectedLabel("");
        getTechTicket("");
    };

    const handleSearch = () => {
        let queryParams = [];
        if (searchQuery) queryParams.push(`search=${searchQuery}`);
        if (selectedStatus) queryParams.push(`state_id=${selectedStatus}`);
        if (selectedPriority) queryParams.push(`priority=${selectedPriority}`);

        const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : "";
        getTechTicket(queryString);
    };

    const getPriorityLabel = (priorityValue: number) => {
        if (priorityValue === 0) return "None";
        if (priorityValue === 1) return "Low";
        if (priorityValue === 2) return "Medium";
        if (priorityValue === 3) return "High";
        if (priorityValue === 4) return "Urgent";
        return "None";
    };

    return (
        <main className={classes.content}>
            {/* Header */}
            <Box className={classes.header}>
                <Typography className={classes.title}>Tech Tickets</Typography>
                <Button
                    variant="contained"
                    onClick={() => setOpenCreateModal(true)}
                    startIcon={<AddIcon />}
                    disabled={!techTicketUserDetails || techTicketUserDetails?.length === 0}
                    style={{
                        background: (!techTicketUserDetails || techTicketUserDetails?.length === 0) ? "#94a3b8" : "#7c3aed",
                        color: "white",
                        borderRadius: "8px",
                        padding: "8px 20px",
                        textTransform: "none",
                        fontWeight: 600,
                    }}
                >
                    Raise Ticket To Tech Support
                </Button>
            </Box>
            {techTicketUserDetails && techTicketUserDetails?.length === 0 && (
                <p
                    style={{
                        color: "#b91c1c",
                        backgroundColor: "#fee2e2",
                        border: "1px solid #fecaca",
                        padding: "10px 14px",
                        borderRadius: "8px",
                        fontSize: "14px",
                        fontWeight: "500",
                        marginTop: "10px"
                    }}
                >
                    You are not authorized to create tickets. Please contact the support team to get access.
                </p>
            )}


            {/* Search and Filters */}
            <Box mb={2}>
                <Grid container spacing={2} alignItems="stretch" style={{ marginBottom: "16px" }}>
                    <Grid item xs={12} md={9}>
                        <TextField
                            fullWidth
                            variant="outlined"
                            placeholder="Search issues by name or ID..."
                            className={classes.searchBox}
                            style={{
                                backgroundColor: "#fff",
                                borderRadius: "10px",
                            }}

                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    handleSearch();
                                }
                            }}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon style={{ color: "#94a3b8" }} />
                                    </InputAdornment>
                                ),
                            }}

                        />
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <Button
                            fullWidth
                            variant="contained"
                            startIcon={<SearchIcon />}
                            onClick={handleSearch}
                            style={{
                                height: "48px",
                                background: "#7c3aed",
                                color: "#fff",
                                borderRadius: "10px",
                                textTransform: "none",
                                fontWeight: 600,
                                fontSize: "14px",
                                boxShadow: "0 2px 6px rgba(124,58,237,0.25)",
                            }}

                        >
                            Search
                        </Button>
                    </Grid>
                </Grid>

                {/* Filter Dropdowns */}
                <Grid container spacing={2} alignItems="stretch" style={{ marginBottom: "16px" }}>
                    <Grid item xs={12} md={2}>
                        <Select
                            fullWidth
                            displayEmpty
                            variant="outlined"
                            className={classes.filterSelect}
                            value={selectedStatus}
                            onChange={(e) => setSelectedStatus(e.target.value)}
                            input={
                                <OutlinedInput
                                    style={{
                                        height: "48px",
                                        borderRadius: "10px",
                                    }}
                                />
                            }
                        >
                            <MenuItem value="">All States</MenuItem>

                            <MenuItem value="5553a160-6332-4e4d-8124-23b7e9f7fb41">Todo</MenuItem>
                            <MenuItem value="14e57618-8608-4416-a5d9-9cfb37527f63">In Progress</MenuItem>
                            <MenuItem value="2db148d5-92a8-4657-9388-7c8ce4bd7da1">Done</MenuItem>
                            <MenuItem value="a65fa495-b551-4198-ae03-3fb997c2faae">Cancelled</MenuItem>
                        </Select>
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <Select
                            fullWidth
                            displayEmpty
                            variant="outlined"
                            className={classes.filterSelect}
                            value={selectedPriority}
                            onChange={(e) => setSelectedPriority(e.target.value)}
                            input={
                                <OutlinedInput
                                    style={{
                                        height: "48px",
                                        borderRadius: "10px",
                                    }}
                                />
                            }
                        >
                            <MenuItem value="">All Priorities</MenuItem>
                            <MenuItem value="0">None</MenuItem>
                            <MenuItem value="1">Low</MenuItem>
                            <MenuItem value="2">Medium</MenuItem>
                            <MenuItem value="3">High</MenuItem>
                        </Select>
                    </Grid>
                    <Grid item xs={6} md={2}>
                        <Select
                            fullWidth
                            displayEmpty
                            variant="outlined"
                            className={classes.filterSelect}
                            value={selectedLabel}
                            onChange={(e) => setSelectedLabel(e.target.value)}
                        >
                            <MenuItem value="">All Labels</MenuItem>
                            <MenuItem value="offlineSupport">offlineSupport</MenuItem>
                        </Select>
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <Button
                            fullWidth
                            variant="outlined"
                            onClick={handleReset}
                            style={{
                                height: "48px",
                                borderRadius: "10px",
                                borderColor: "#ef4444",
                                color: "#ef4444",
                                textTransform: "none",
                                fontWeight: 600,
                                fontSize: "14px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                            }}


                        >
                            Reset
                        </Button>
                    </Grid>
                </Grid>
            </Box>

            {/* Table */}
            <TableContainer component={Paper} className={classes.tableContainer}>
                <Table>
                    <TableHead>
                        <StyledTableRow>
                            <StyledTableCell>ID</StyledTableCell>
                            <StyledTableCell>TITLE</StyledTableCell>
                            <StyledTableCell>STATE</StyledTableCell>
                            <StyledTableCell>PRIORITY</StyledTableCell>
                            <StyledTableCell>ASSIGNEES</StyledTableCell>
                            <StyledTableCell>DUE DATE</StyledTableCell>
                            <StyledTableCell align="center">View</StyledTableCell>
                        </StyledTableRow>
                    </TableHead>
                    <TableBody>
                        {techTicketDetails?.issues &&
                            techTicketDetails?.issues.length > 0 &&
                            techTicketDetails?.issues?.map((ticket: any, index: any) => {
                                const stateColor = getStateColor(ticket.state?.name?.toLowerCase().replace(/\s+/g, '_') || "no_state");
                                return (
                                    <StyledTableRow key={index}>
                                        <StyledTableCell>
                                            <Typography className={classes.ticketId}>
                                                {ticket.identifier || `#${ticket.sequence_id}`}
                                            </Typography>
                                        </StyledTableCell>

                                        <StyledTableCell>
                                            <Typography className={classes.ticketTitle}>
                                                {ticket.name || "Untitled"}
                                            </Typography>
                                        </StyledTableCell>

                                        <StyledTableCell>
                                            <Chip
                                                label={ticket.state?.name || "No state"}
                                                className={classes.stateChip}
                                                style={{
                                                    backgroundColor: stateColor.bg,
                                                    color: stateColor.color,
                                                }}
                                                size="small"
                                            />
                                        </StyledTableCell>

                                        <StyledTableCell>
                                            <Box className={classes.priorityIndicator}>
                                                <div
                                                    className={classes.priorityBar}
                                                    style={{
                                                        backgroundColor: getPriorityColor(
                                                            ticket.priority === 0 ? "none" :
                                                                ticket.priority === 1 ? "low" :
                                                                    ticket.priority === 2 ? "medium" : "high"
                                                        ),
                                                    }}
                                                />
                                                <Typography className={classes.priorityText}>
                                                    {getPriorityLabel(ticket.priority)}
                                                </Typography>
                                            </Box>
                                        </StyledTableCell>

                                        <StyledTableCell>
                                            <AvatarGroup max={3} className={classes.avatarGroup}>
                                                {ticket.assignees && ticket.assignees.length > 0 ? (
                                                    ticket.assignees.map((assignee: any, idx: number) => (
                                                        <Tooltip key={idx} title={assignee.display_name}>
                                                            <Avatar
                                                                src={assignee.avatar_url}
                                                                style={{
                                                                    backgroundColor: `hsl(${idx * 60}, 70%, 60%)`,
                                                                }}
                                                            >
                                                                {assignee.display_name?.charAt(0).toUpperCase()}
                                                            </Avatar>
                                                        </Tooltip>
                                                    ))
                                                ) : (
                                                    <Typography className={classes.priorityText}>—</Typography>
                                                )}
                                            </AvatarGroup>
                                        </StyledTableCell>

                                        <StyledTableCell>
                                            <Typography className={classes.dateText}>
                                                {ticket.target_date
                                                    ? new Date(ticket.target_date).toLocaleDateString("en-US", {
                                                        month: "short",
                                                        day: "numeric",
                                                        year: "numeric",
                                                    })
                                                    : "—"}
                                            </Typography>
                                        </StyledTableCell>

                                        <StyledTableCell align="center">
                                            <Box display="flex" gap="2px" justifyContent="center">
                                                <Tooltip title="View">
                                                    <IconButton
                                                        size="small"
                                                        className={classes.actionButton}
                                                        onClick={() => handleViewTicket(ticket)}
                                                    >
                                                        <VisibilityIcon fontSize="small" />
                                                    </IconButton>
                                                </Tooltip>
                                            </Box>
                                        </StyledTableCell>
                                    </StyledTableRow>
                                );
                            })}
                    </TableBody>
                </Table>
                <Box p={2}>
                    <TablePagination
                        component="div"
                        count={techTicketDetails.total || 0}
                        page={page}
                        onPageChange={handleChangePage}
                        rowsPerPage={techTicketDetails.per_page || 50}
                        rowsPerPageOptions={[]}
                    />
                </Box>
            </TableContainer>

            {/* View Ticket Modal */}
            <Dialog
                open={openViewModal}
                onClose={() => setOpenViewModal(false)}
                maxWidth="md"
                fullWidth
                className={classes.viewDialog}
            >
                <DialogTitle className={classes.dialogTitle} disableTypography>
                    <Typography className={classes.titleText}>
                        Ticket Details
                    </Typography>
                    <IconButton
                        className={classes.closeButton}
                        onClick={() => setOpenViewModal(false)}
                        size="small"
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>

                <DialogContent className={classes.dialogContent}>
                    {selectedTicket && (
                        <>
                            {/* Ticket ID */}
                            <Box className={classes.detailRow}>
                                <Typography className={classes.detailLabel}>ID</Typography>
                                <Typography className={classes.detailValue}>
                                    {selectedTicket.identifier || `#${selectedTicket.sequence_id}`}
                                </Typography>
                            </Box>

                            {/* Title */}
                            <Box className={classes.detailRow}>
                                <Typography className={classes.detailLabel}>Title</Typography>
                                <Typography className={classes.detailValue}>
                                    {selectedTicket.name || "Untitled"}
                                </Typography>
                            </Box>

                            {/* State */}
                            <Box className={classes.detailRow}>
                                <Typography className={classes.detailLabel}>State</Typography>
                                <Box>
                                    <Chip
                                        label={selectedTicket.state?.name || "No state"}
                                        className={classes.stateChip}
                                        style={{
                                            backgroundColor: getStateColor(
                                                selectedTicket.state?.name?.toLowerCase().replace(/\s+/g, '_') || "no_state"
                                            ).bg,
                                            color: getStateColor(
                                                selectedTicket.state?.name?.toLowerCase().replace(/\s+/g, '_') || "no_state"
                                            ).color,
                                        }}
                                        size="small"
                                    />
                                </Box>
                            </Box>

                            {/* Priority */}
                            <Box className={classes.detailRow}>
                                <Typography className={classes.detailLabel}>Priority</Typography>
                                <Box className={classes.priorityIndicator}>
                                    <div
                                        className={classes.priorityBar}
                                        style={{
                                            backgroundColor: getPriorityColor(
                                                selectedTicket.priority === 0 ? "none" :
                                                    selectedTicket.priority === 1 ? "low" :
                                                        selectedTicket.priority === 2 ? "medium" : "high"
                                            ),
                                        }}
                                    />
                                    <Typography className={classes.priorityText}>
                                        {getPriorityLabel(selectedTicket.priority)}
                                    </Typography>
                                </Box>
                            </Box>

                            {/* Due Date */}
                            <Box className={classes.detailRow}>
                                <Typography className={classes.detailLabel}>Due Date</Typography>
                                <Typography className={classes.detailValue}>
                                    {selectedTicket.target_date
                                        ? new Date(selectedTicket.target_date).toLocaleDateString("en-US", {
                                            month: "long",
                                            day: "numeric",
                                            year: "numeric",
                                        })
                                        : "No due date set"}
                                </Typography>
                            </Box>

                            {/* Assignees */}
                            <Box className={classes.detailRow}>
                                <Typography className={classes.detailLabel}>Assignees</Typography>
                                <Box className={classes.detailValue}>
                                    {selectedTicket.assignees && selectedTicket.assignees.length > 0 ? (
                                        <Box className={classes.assigneesList}>
                                            {selectedTicket.assignees.map((assignee: any, idx: number) => (
                                                <Box key={idx} className={classes.assigneeItem}>
                                                    <Avatar
                                                        src={assignee.avatar_url}
                                                        style={{
                                                            width: "24px",
                                                            height: "24px",
                                                            fontSize: "11px",
                                                            backgroundColor: `hsl(${idx * 60}, 70%, 60%)`,
                                                        }}
                                                    >
                                                        {assignee.display_name?.charAt(0).toUpperCase()}
                                                    </Avatar>
                                                    <Typography style={{ fontSize: "13px" }}>
                                                        {assignee.display_name}
                                                    </Typography>
                                                </Box>
                                            ))}
                                        </Box>
                                    ) : (
                                        <Typography className={classes.detailValue}>
                                            No assignees
                                        </Typography>
                                    )}
                                </Box>
                            </Box>

                            {/* Description */}
                            <Box className={classes.detailRow} style={{ flexDirection: "column", alignItems: "flex-start" }}>
                                <Typography className={classes.detailLabel}>Description</Typography>
                                <Box className={classes.descriptionBox} style={{ width: "100%" }}>
                                    {renderDescriptionWithImages(selectedTicket.description)}
                                </Box>
                            </Box>

                            {/* Attachments Section */}
                            <Box className={classes.detailRow} style={{ flexDirection: "column", alignItems: "flex-start" }}>
                                <Box display="flex" justifyContent="space-between" alignItems="center" width="100%" mb={1}>
                                    <Typography className={classes.detailLabel}>Attachments</Typography>
                                    <Button
                                        size="small"
                                        startIcon={<AddIcon />}
                                        onClick={triggerFileUpload}
                                        style={{
                                            color: "#7c3aed",
                                            textTransform: "none",
                                            fontWeight: 600,
                                        }}
                                    >
                                        Add File
                                    </Button>
                                </Box>
                                <Box className={classes.attachmentGrid} style={{ width: "100%" }}>
                                    {attachments && attachments.length > 0 ? (
                                        attachments.map((attachment: any, idx: number) => {
                                            const fileIcon = getFileIcon(attachment);
                                            return (
                                                <Box
                                                    key={idx}
                                                    className={classes.attachmentCard}
                                                    onClick={() => window.open(attachment.url, '_blank')}
                                                >
                                                    {attachment.is_image ? (
                                                        <img
                                                            src={attachment.url}
                                                            alt={attachment.original_filename}
                                                            className={classes.attachmentImage}
                                                            onError={(e: any) => {
                                                                e.target.style.display = 'none';
                                                                const nextSibling = e.target.nextElementSibling;
                                                                if (nextSibling) {
                                                                    nextSibling.style.display = 'flex';
                                                                }
                                                            }}
                                                        />
                                                    ) : null}

                                                    <Box
                                                        className={classes.attachmentImage}
                                                        display={attachment.is_image ? "none" : "flex"}
                                                        alignItems="center"
                                                        justifyContent="center"
                                                        flexDirection="column"
                                                        style={{
                                                            backgroundColor: "#f8fafc",
                                                            border: `2px solid ${fileIcon.color}20`,
                                                        }}
                                                    >
                                                        <Typography
                                                            style={{
                                                                fontSize: "48px",
                                                                marginBottom: "8px"
                                                            }}
                                                        >
                                                            {fileIcon.emoji}
                                                        </Typography>
                                                        <Typography
                                                            style={{
                                                                fontSize: "11px",
                                                                color: fileIcon.color,
                                                                fontWeight: 600,
                                                                textTransform: "uppercase",
                                                                letterSpacing: "0.5px"
                                                            }}
                                                        >
                                                            {getFileTypeLabel(attachment)}
                                                        </Typography>
                                                    </Box>

                                                    <Box className={classes.attachmentInfo}>
                                                        <Tooltip title={attachment.original_filename}>
                                                            <Typography className={classes.attachmentName}>
                                                                {attachment.original_filename}
                                                            </Typography>
                                                        </Tooltip>
                                                        <Box display="flex" justifyContent="space-between" alignItems="center">
                                                            <Typography className={classes.attachmentSize}>
                                                                {attachment.file_size_display}
                                                            </Typography>
                                                            <Typography
                                                                style={{
                                                                    fontSize: "10px",
                                                                    color: "#94a3b8",
                                                                    fontStyle: "italic"
                                                                }}
                                                            >
                                                                Click to open
                                                            </Typography>
                                                        </Box>
                                                    </Box>
                                                </Box>
                                            );
                                        })
                                    ) : (
                                        <Box className={classes.addFileButton} onClick={triggerFileUpload}>
                                            <AddIcon style={{ fontSize: "32px", color: "#94a3b8" }} />
                                            <Typography style={{ fontSize: "13px", color: "#64748b", marginTop: "8px" }}>
                                                No attachments yet
                                            </Typography>
                                            <Typography style={{ fontSize: "12px", color: "#94a3b8" }}>
                                                Click to add files
                                            </Typography>
                                        </Box>
                                    )}
                                </Box>
                            </Box>

                            {/* Activity Section with Tabs */}
                            <Box className={classes.commentsSection}>
                                <Box className={classes.tabsContainer} display="flex" gap="24px">
                                    <Typography
                                        className={`${classes.tab} ${activeTab === "history" ? classes.activeTab : ""}`}
                                        onClick={() => setActiveTab("history")}
                                    >
                                        History
                                    </Typography>
                                    <Typography
                                        className={`${classes.tab} ${activeTab === "comments" ? classes.activeTab : ""}`}
                                        onClick={() => setActiveTab("comments")}
                                    >
                                        Comments
                                    </Typography>
                                    <Typography
                                        className={`${classes.tab} ${activeTab === "attachments" ? classes.activeTab : ""}`}
                                        onClick={() => setActiveTab("attachments")}
                                    >
                                        Attachments
                                    </Typography>
                                </Box>

                                {activeTab === "comments" && (
                                    <>
                                        {/* Comments List */}
                                        <Box className={classes.commentsList}>
                                            {techTicketComments && techTicketComments.length > 0 ? (
                                                techTicketComments.map((comment: any, idx: number) => (
                                                    <Box key={idx} className={classes.commentItem}>
                                                        <Box className={classes.commentAvatar}>
                                                            {comment.user?.display_name?.charAt(0).toUpperCase() || "U"}
                                                        </Box>
                                                        <Box className={classes.commentContent}>
                                                            <Box className={classes.commentHeader}>
                                                                <Typography className={classes.commentAuthor}>
                                                                    {comment.user?.display_name || "Unknown User"}
                                                                </Typography>
                                                                <Typography className={classes.commentTime}>
                                                                    {comment.created_at
                                                                        ? new Date(comment.created_at).toLocaleDateString("en-US", {
                                                                            month: "short",
                                                                            day: "numeric",
                                                                            year: "numeric",
                                                                            hour: "2-digit",
                                                                            minute: "2-digit",
                                                                        })
                                                                        : ""}
                                                                </Typography>
                                                            </Box>
                                                            <Typography className={classes.commentText}>
                                                                {comment.content}
                                                            </Typography>
                                                        </Box>
                                                    </Box>
                                                ))
                                            ) : (
                                                <Typography style={{ fontSize: "14px", color: "#94a3b8", textAlign: "center", padding: "20px" }}>
                                                    No comments yet. Be the first to comment!
                                                </Typography>
                                            )}
                                        </Box>

                                        {/* Add Comment Input */}
                                        <Box className={classes.commentInputBox}>
                                            <Avatar
                                                style={{
                                                    width: "36px",
                                                    height: "36px",
                                                    backgroundColor: "#7c3aed",
                                                    flexShrink: 0,
                                                }}
                                            >
                                                K
                                            </Avatar>
                                            <Box flex={1}>
                                                <TextField
                                                    fullWidth
                                                    multiline
                                                    rows={3}
                                                    variant="outlined"
                                                    placeholder="Add a comment... Use @username to mention someone"
                                                    value={newComment}
                                                    onChange={(e) => setNewComment(e.target.value)}
                                                    className={classes.commentTextField}
                                                />
                                                <Box display="flex" justifyContent="space-between" alignItems="center" mt={1}>
                                                    <Typography style={{ fontSize: "12px", color: "#94a3b8" }}>
                                                        Tip: Use @username to mention someone
                                                    </Typography>
                                                    <Button
                                                        variant="contained"
                                                        onClick={handleAddComment}
                                                        disabled={!newComment.trim()}
                                                        style={{
                                                            background: newComment.trim() ? "#7c3aed" : "#e2e8f0",
                                                            color: "white",
                                                            borderRadius: "8px",
                                                            padding: "8px 24px",
                                                            textTransform: "none",
                                                            fontWeight: 600,
                                                        }}
                                                    >
                                                        Comment
                                                    </Button>
                                                </Box>
                                            </Box>
                                        </Box>
                                    </>
                                )}

                                {activeTab === "history" && (
                                    <Box style={{ padding: "20px" }}>
                                        {techTicketActivities && techTicketActivities.length > 0 ? (
                                            <Box display="flex" flexDirection="column" gap="20px" style={{ padding: "8px" }}>
                                                {techTicketActivities.map((activity: any, idx: number) => (
                                                    <Box key={idx} className={classes.commentItem}>
                                                        <Box className={classes.commentAvatar}>
                                                            {activity.user_name?.charAt(0).toUpperCase() || "S"}
                                                        </Box>
                                                        <Box className={classes.commentContent}>
                                                            <Box className={classes.commentHeader}>
                                                                <Typography className={classes.commentAuthor}>
                                                                    {activity.user_name || "System"}
                                                                </Typography>
                                                                <Typography className={classes.commentTime}>
                                                                    {activity.created_at
                                                                        ? new Date(activity.created_at).toLocaleDateString("en-US", {
                                                                            month: "short",
                                                                            day: "numeric",
                                                                            year: "numeric",
                                                                            hour: "2-digit",
                                                                            minute: "2-digit",
                                                                        })
                                                                        : ""}
                                                                </Typography>
                                                            </Box>
                                                            <Typography className={classes.commentText}>
                                                                {activity.activity_type === "created" && (
                                                                    <>Created issue: <strong>{activity.new_value}</strong></>
                                                                )}
                                                                {activity.activity_type === "updated" && (
                                                                    <>Updated <strong>{activity.field}</strong>: {activity.old_value} → {activity.new_value}</>
                                                                )}
                                                                {activity.activity_type === "assigned" && (
                                                                    <>Assigned to <strong>{activity.new_value}</strong></>
                                                                )}
                                                                {activity.activity_type === "status_changed" && (
                                                                    <>Status changed to <strong>{activity.new_value}</strong></>
                                                                )}
                                                                {!["created", "updated", "assigned", "status_changed"].includes(activity.activity_type) && (
                                                                    <>{activity.activity_type}: {activity.new_value}</>
                                                                )}
                                                            </Typography>
                                                        </Box>
                                                    </Box>
                                                ))}
                                            </Box>
                                        ) : (
                                            <Typography style={{ fontSize: "14px", color: "#94a3b8", textAlign: "center", padding: "20px" }}>
                                                No activity history yet.
                                            </Typography>
                                        )}
                                    </Box>
                                )}

                                {activeTab === "attachments" && (
                                    <Box style={{ padding: "20px" }}>
                                        <Box className={classes.attachmentGrid} style={{ width: "100%" }}>
                                            {techTicketAttacments && techTicketAttacments.length > 0 ? (
                                                techTicketAttacments.map((attachment: any, idx: number) => {
                                                    const fileIcon = getFileIcon(attachment);

                                                    return (
                                                        <Box
                                                            key={idx}
                                                            className={classes.attachmentCard}
                                                            onClick={() => window.open(attachment.url, '_blank')}
                                                        >
                                                            {attachment.is_image ? (
                                                                <img
                                                                    src={attachment.url}
                                                                    alt={attachment.original_filename}
                                                                    className={classes.attachmentImage}
                                                                    onError={(e: any) => {
                                                                        e.target.style.display = 'none';
                                                                        const nextSibling = e.target.nextElementSibling;
                                                                        if (nextSibling) {
                                                                            nextSibling.style.display = 'flex';
                                                                        }
                                                                    }}
                                                                />
                                                            ) : null}

                                                            <Box
                                                                className={classes.attachmentImage}
                                                                display={attachment.is_image ? "none" : "flex"}
                                                                alignItems="center"
                                                                justifyContent="center"
                                                                flexDirection="column"
                                                                style={{
                                                                    backgroundColor: "#f8fafc",
                                                                    border: `2px solid ${fileIcon.color}20`,
                                                                }}
                                                            >
                                                                <Typography
                                                                    style={{
                                                                        fontSize: "48px",
                                                                        marginBottom: "8px"
                                                                    }}
                                                                >
                                                                    {fileIcon.emoji}
                                                                </Typography>
                                                                <Typography
                                                                    style={{
                                                                        fontSize: "11px",
                                                                        color: fileIcon.color,
                                                                        fontWeight: 600,
                                                                        textTransform: "uppercase",
                                                                        letterSpacing: "0.5px"
                                                                    }}
                                                                >
                                                                    {getFileTypeLabel(attachment)}
                                                                </Typography>
                                                            </Box>

                                                            <Box className={classes.attachmentInfo}>
                                                                <Tooltip title={attachment.original_filename}>
                                                                    <Typography className={classes.attachmentName}>
                                                                        {attachment.original_filename}
                                                                    </Typography>
                                                                </Tooltip>
                                                                <Box display="flex" justifyContent="space-between" alignItems="center">
                                                                    <Typography className={classes.attachmentSize}>
                                                                        {attachment.file_size_display}
                                                                    </Typography>
                                                                    <Typography
                                                                        style={{
                                                                            fontSize: "10px",
                                                                            color: "#94a3b8",
                                                                            fontStyle: "italic"
                                                                        }}
                                                                    >
                                                                        Click to open
                                                                    </Typography>
                                                                </Box>
                                                            </Box>
                                                        </Box>
                                                    );
                                                })
                                            ) : (
                                                <Box className={classes.addFileButton} onClick={triggerFileUpload}>
                                                    <AddIcon style={{ fontSize: "32px", color: "#94a3b8" }} />
                                                    <Typography style={{ fontSize: "13px", color: "#64748b", marginTop: "8px" }}>
                                                        No attachments yet
                                                    </Typography>
                                                    <Typography style={{ fontSize: "12px", color: "#94a3b8" }}>
                                                        Click to add files
                                                    </Typography>
                                                </Box>
                                            )}
                                        </Box>
                                    </Box>
                                )}
                            </Box>
                        </>
                    )}
                </DialogContent>
            </Dialog>

            {/* Create Ticket Modal */}
            <Dialog
                open={openCreateModal}
                onClose={() => setOpenCreateModal(false)}
                maxWidth="md"
                fullWidth
                className={classes.dialog}
            >
                <DialogTitle className={classes.dialogTitle} disableTypography>
                    <Typography className={classes.titleText}>Create Issue</Typography>
                    <IconButton
                        className={classes.closeButton}
                        onClick={() => setOpenCreateModal(false)}
                        size="small"
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>

                <DialogContent className={classes.dialogContent}>
                    {/* Title */}
                    <Box mb={3}>
                        <Typography className={classes.sectionTitle}>Title</Typography>
                        <TextField
                            fullWidth
                            variant="outlined"
                            placeholder="Enter issue title..."
                            value={createFormData.title}
                            onChange={(e) =>
                                setCreateFormData({ ...createFormData, title: e.target.value })
                            }
                        />
                    </Box>

                    {/* Description */}
                    <Box mb={3}>
                        <Typography className={classes.sectionTitle}>Description</Typography>
                        <Box className={classes.editorContainer}>
                            {/* Editor Toolbar */}
                            <Box className={classes.editorToolbar}>
                                <Select
                                    value="Normal"
                                    variant="outlined"
                                    style={{
                                        height: "32px",
                                        fontSize: "14px",
                                        minWidth: "100px",
                                    }}
                                >
                                    <MenuItem value="Normal">Normal</MenuItem>
                                    <MenuItem value="Heading 1">Heading 1</MenuItem>
                                    <MenuItem value="Heading 2">Heading 2</MenuItem>
                                    <MenuItem value="Heading 3">Heading 3</MenuItem>
                                </Select>
                                <IconButton
                                    size="small"
                                    className={classes.editorButton}
                                    onClick={handleBold}
                                    title="Bold"
                                >
                                    <strong>B</strong>
                                </IconButton>
                                <IconButton
                                    size="small"
                                    className={classes.editorButton}
                                    onClick={handleItalic}
                                    title="Italic"
                                >
                                    <em>I</em>
                                </IconButton>
                                <IconButton
                                    size="small"
                                    className={classes.editorButton}
                                    onClick={handleUnderline}
                                    title="Underline"
                                >
                                    <u>U</u>
                                </IconButton>
                                <IconButton
                                    size="small"
                                    className={classes.editorButton}
                                    onClick={handleStrikethrough}
                                    title="Strikethrough"
                                >
                                    <s>S</s>
                                </IconButton>
                                <IconButton
                                    size="small"
                                    className={classes.editorButton}
                                    onClick={handleCode}
                                    title="Code"
                                >
                                    {"</>"}
                                </IconButton>
                                <IconButton
                                    size="small"
                                    className={classes.editorButton}
                                    onClick={handleQuote}
                                    title="Quote"
                                >
                                    {'"'}
                                </IconButton>
                                <IconButton
                                    size="small"
                                    className={classes.editorButton}
                                    onClick={handleBulletList}
                                    title="Bullet List"
                                >
                                    ☰
                                </IconButton>
                                <IconButton
                                    size="small"
                                    className={classes.editorButton}
                                    onClick={handleNumberedList}
                                    title="Numbered List"
                                >
                                    ≣
                                </IconButton>
                                <IconButton
                                    size="small"
                                    className={classes.editorButton}
                                    onClick={handleLinkInsert}
                                    title="Insert Link"
                                >
                                    🔗
                                </IconButton>
                                <IconButton
                                    size="small"
                                    className={classes.editorButton}
                                    onClick={handleImageUpload}
                                    title="Upload Image"
                                >
                                    🖼
                                </IconButton>
                            </Box>

                            {/* Text Area */}
                            <TextField
                                fullWidth
                                multiline
                                rows={8}
                                variant="outlined"
                                placeholder="Add description, paste images, use markdown..."
                                value={createFormData.description}
                                onChange={(e) =>
                                    setCreateFormData({
                                        ...createFormData,
                                        description: e.target.value,
                                    })
                                }
                                className={classes.editorTextarea}
                                inputRef={descriptionRef}
                            />
                        </Box>

                        {/* Preview Area */}
                        {(createFormData.description || uploadedImages.length > 0) && (
                            <Box mt={2}>
                                <Typography className={classes.sectionTitle}>Preview</Typography>
                                <Box className={classes.descriptionPreview}>
                                    {createFormData.description && (
                                        <Typography component="span" style={{ fontSize: "14px", lineHeight: "1.6", whiteSpace: "pre-wrap" }}>
                                            {createFormData.description}
                                        </Typography>
                                    )}
                                    {uploadedImages.length > 0 && (
                                        <Box mt={2}>
                                            {uploadedImages.map((img, idx) => (
                                                <Box key={idx} position="relative" display="inline-block" mr={2} mb={2}>
                                                    <img
                                                        src={img.data}
                                                        alt={img.name}
                                                        style={{
                                                            maxWidth: "300px",
                                                            height: "auto",
                                                            borderRadius: "8px",
                                                            display: "block",
                                                            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                                                        }}
                                                    />
                                                    <IconButton
                                                        size="small"
                                                        onClick={() => setUploadedImages(prev => prev.filter((_, i) => i !== idx))}
                                                        style={{
                                                            position: "absolute",
                                                            top: "8px",
                                                            right: "8px",
                                                            backgroundColor: "rgba(239, 68, 68, 0.9)",
                                                            color: "white",
                                                            padding: "4px",
                                                        }}
                                                    >
                                                        <CloseIcon fontSize="small" />
                                                    </IconButton>
                                                    <Typography
                                                        style={{
                                                            fontSize: "11px",
                                                            color: "#64748b",
                                                            marginTop: "4px",
                                                            textAlign: "center"
                                                        }}
                                                    >
                                                        {img.name}
                                                    </Typography>
                                                </Box>
                                            ))}
                                        </Box>
                                    )}
                                </Box>
                            </Box>
                        )}
                    </Box>

                    {/* Priority */}
                    <Box mb={3}>
                        <Typography className={classes.sectionTitle}>Priority</Typography>
                        <Box display="flex" gap="8px" flexWrap="wrap">
                            {priorities.map((priority) => (
                                <Chip
                                    key={priority.value}
                                    label={priority.label}
                                    className={classes.priorityChip}
                                    style={{
                                        backgroundColor:
                                            createFormData.priority === priority.value
                                                ? priority.color
                                                : "#f5f5f5",
                                        color:
                                            createFormData.priority === priority.value
                                                ? "white"
                                                : "#666",
                                    }}
                                    onClick={() =>
                                        setCreateFormData({
                                            ...createFormData,
                                            priority: priority.value,
                                        })
                                    }
                                />
                            ))}
                        </Box>
                    </Box>

                    {/* Action Buttons */}
                    <Box display="flex" justifyContent="flex-end" gap="12px" mt={3}>
                        <Button
                            variant="outlined"
                            className={classes.cancelButton}
                            onClick={() => setOpenCreateModal(false)}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant="contained"
                            className={classes.submitButton}
                            onClick={handleCreateTicket}
                        >
                            Create
                        </Button>
                    </Box>
                </DialogContent>
            </Dialog>
        </main>
    );
};

const mapStateToProps = (state: any) => ({
    techTicketDetails: state.OffLineSupporteReducer.techTicketDetails,
    techTicketActivities: state.OffLineSupporteReducer.techTicketActivities,
    techTicketComments: state.OffLineSupporteReducer.techTicketComments,
    techTicketAttacments: state.OffLineSupporteReducer.techTicketAttacments,
    techTicketUserDetails: state.OffLineSupporteReducer.techTicketUserDetails,
    userDetails: state.OffLineSupporteReducer.userDetails,


});

export default connect(mapStateToProps, {
    getTechTicket,
    postTechTicket,
    postTechTicketIssueAttacment,
    postTechTicketComment,
    getTechTicketActivites,
    getTechTicketComments,
    getTechTicketAttacment,
    getTechTicketUserDetails
})(BookingsTable);